import { UserContext } from '@/contexts/user-context'
import { useContext } from 'react'

export const useMe = () => {
  const context = useContext(UserContext)
  if (context === undefined) throw new Error('useMe must be used within a UserProvider')
  return context
}
